import Radium from 'radium';
import React, { useEffect } from "react";
import {Navbar} from "../components/Navbar";
import {GalleryComponent} from "../components/GalleryComponent";
import {Onglets} from "../components/Onglets";
import ScrollToHash from "../components/ScroolToHash";

export const Home = () => {
  useEffect(() => {
    // Initialisation des backgrounds
    window.$(".bg-img, section").each(function () {
      if (window.$(this).attr("data-background")) {
        window.$(this).css("background-image", "url(" + window.$(this).data("background") + ")");
      }
    });

    // Initialisation du carrousel principal
    window.$(".owl-carousel").owlCarousel({
      items: 1,
      loop: true,
      margin: 0,
      nav: false,
      dots: true,
      autoplay: true,
      autoplayTimeout: 5000,
      smartSpeed: 1000,
      animateIn: "fadeIn",
      animateOut: "fadeOut",
      responsive: {
        0: {
          items: 1
        },
        768: {
          items: 1
        }
      }
    });

    // Nettoyage lors du démontage du composant
    return () => {
      window.$(".owl-carousel").trigger('destroy.owl.carousel');
    };
  }, []);

  return (
    <div>
      {/* <!-- Preloader --> */}
      {/*<div className="preloader-bg"></div>
      <div id="preloader">
        <div id="preloader-status">
          <div className="preloader-position loader"> <span></span> </div>
        </div>
      </div>*/}
      {/* <!-- Progress scroll totop --> */}
      <div className="progress-wrap cursor-pointer">
        <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
          <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
        </svg>
      </div>
      {/* <!-- Navbar --> */}
      <ScrollToHash />
      <Navbar/>
      {/* <!-- Slider --> */}
      <header id="home" className="header slider-fade" data-scroll-index="0">
        <div className="owl-carousel owl-theme">
          {/* <!-- The opacity on the image is made with "data-overlay-dark="number".You can change it using the numbers 0-9. --> */}
          <div className="text-left item bg-img" data-overlay-dark="5" data-background="./assets/images/home/trees-3822149.jpg">
            <div className="v-middle caption">
              <div className="container">
                <div className="row">
                  <div className="col-md-8 col-sm-12 mt-30">
                    <div className="o-hidden">
                      {/*<h6><strong>Transmission</strong></h6>*/}
                      <h1 className="slider-title">Société de conseil et d'ingénierie en écologie</h1>
                      {/*<p><strong>Société de conseil et d'ingénierie en écologie.</strong></p>*/}
                      {/*-<a href="project-page.html" className="btn float-btn flat-btn">Discover</a>*/}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="text-left item bg-img" data-overlay-dark="3" data-background="./assets/images/home/lake.jpg">
            <div className="v-middle caption">
              <div className="container">
                <div className="row">
                  <div className="col-md-8 col-sm-12 mt-30">
                    <div className="o-hidden">
                      {/*<h6><strong>Transmission</strong></h6>*/}
                      <h1 className="slider-title">Société de conseil et d'ingénierie en écologie</h1>
                      {/*<p><strong>Société de conseil et d'ingénierie en écologie.</strong></p>*/}
                      {/*-<a href="project-page.html" className="btn float-btn flat-btn">Discover</a>*/}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="text-left item bg-img" data-overlay-dark="4" data-background="./assets/images/home/japan.jpg">
            <div className="v-middle caption">
              <div className="container">
                <div className="row">
                  <div className="col-md-8 col-sm-12 mt-30">
                    <div className="o-hidden">
                      {/*<h6><strong>Transmission</strong></h6>*/}
                      <h1 className="slider-title">Société de conseil et d'ingénierie en écologie</h1>
                      {/*<p><strong>Société de conseil et d'ingénierie en écologie.</strong></p>*/}
                      {/*-<a href="project-page.html" className="btn float-btn flat-btn">Discover</a>*/}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <Onglets />
      {/* <!-- About --> */}
      <div id="about" className="about section-padding" data-scroll-index="1">
        <div className="container">
          <div className="row">
            <div className="col-md-7">
              <div className="section-title">À Propos de nous</div>
              <p>NATURAE est un bureau d'étude et de conseil scientifique en écologie,</p>
              <p>Afin d'accompagner des projets permettant de :</p>
              <ul type={"circle"}>
                <li>• intégrer</li>
                <li>• préserver</li>
                <li>• restaurer </li>
                <li>• transmettre</li>
              </ul>
              <p className="text-color">la nature et donc la biodiversité.</p>
              <p>Les pôles d'expertise, tant dans le secteur public que privé, sont : </p>
              <p><strong>Diagnostic écologique & Expertise naturaliste : </strong>Certifications & labels, expertise naturaliste et écologue, restauration des écosystème.</p>
              <p><strong>Etude d'impact & autres réglementations</strong> (DLE Zones Humides, Etudes d'Incidences, ZAN, etc.)</p>
              <p><strong>Stratégie d'entreprise & Conduite du changement : </strong>L'accompagnement  stratégique et opérationnel</p>
              <p><strong>Transmission & Animation :</strong> L'animation d'ateliers et la concertation publique, Formation (ESSEC, MBA, etc.)</p>
              <p>NATURAE s'associe, pour la complétude des études faune flore d'ordre réglementaire, à des naturalistes indépendants.</p>
            </div>
            <div className="col-md-5">
              <div className="about-img">
                <div className="img"> <img src="./assets/images/home/img-about.png" className="img-fluid" alt=""/> </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="galerie" className="parallax-header parallax-slider-fade" data-scroll-index="3">
        <div className="owl-carousel owl-theme">
          {/* <!-- The opacity on the image is made with "data-overlay-dark="number". You can change it using the numbers 0-9. --> */}

          <div className="text-left item bg-img" data-overlay-dark="3" data-background="./assets/images/gallery/feuilles.jpg">
            <div className="v-middle caption">
              <div className="container">
                <div className="row">
                  <div className="col-md-8">
                    <div className="o-hidden">
                      {/*<h6>Découvrir</h6>*/}
                      <h2>Nature</h2>
                      {/*<p><a href="#"><i className="ti-location-pin"></i> Princeton, NJ, United States</a></p>*/}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="text-left item bg-img" data-overlay-dark="3" data-background="./assets/images/gallery/fleurs.jpg">
            <div className="v-middle caption">
              <div className="container">
                <div className="row">
                  <div className="col-md-8">
                    <div className="o-hidden">
                      {/*<h6>Découvrir</h6>*/}
                      <h2>Diversité</h2>
                      {/*<p><a href="#"><i className="ti-location-pin"></i> Ashburn, VA, United States</a></p>*/}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="text-left item bg-img" data-overlay-dark="3" data-background="./assets/images/gallery/Galerie1.jpg">
            <div className="v-middle caption">
              <div className="container">
                <div className="row">
                  <div className="col-md-8">
                    <div className="o-hidden">
                      {/*<h6>Découvrir</h6>*/}
                      <h2>Biodiversité</h2>
                      {/*<p><a href="#"><i className="ti-location-pin"></i> Ashburn, VA, United States</a></p>*/}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="text-left item bg-img-bottom bg-img" data-overlay-dark="3" data-background="./assets/images/gallery/Galerie2.jpeg">
            <div className="v-middle caption">
              <div className="container">
                <div className="row">
                  <div className="col-md-8">
                    <div className="o-hidden">
                      {/*<h6>Découvrir</h6>*/}
                      <h2>Faune</h2>
                      {/*<p><a href="#"><i className="ti-location-pin"></i> Ashburn, VA, United States</a></p>*/}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="text-left item bg-img" data-overlay-dark="5" data-background="./assets/images/gallery/Galerie3.jpeg">
            <div className="v-middle caption">
              <div className="container">
                <div className="row">
                  <div className="col-md-8">
                    <div className="o-hidden">
                      {/*<h6>Découvrir</h6>*/}
                      <h2>Flore</h2>
                      {/*<p><a href="#"><i className="ti-location-pin"></i> Ashburn, VA, United States</a></p>*/}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="text-left item bg-img" data-overlay-dark="3" data-background="./assets/images/gallery/ref-Etude-reglementaires.jpg">
            <div className="v-middle caption">
              <div className="container">
                <div className="row">
                  <div className="col-md-8">
                    <div className="o-hidden">
                      {/*<h6>Découvrir</h6>*/}
                      <h2>Etudes</h2>
                      {/*<p><a href="#"><i className="ti-location-pin"></i> Ashburn, VA, United States</a></p>*/}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="text-left item bg-img" data-overlay-dark="3" data-background="./assets/images/gallery/ref_strategie-entreprise.jpeg">
            <div className="v-middle caption">
              <div className="container">
                <div className="row">
                  <div className="col-md-8">
                    <div className="o-hidden">
                      {/*<h6>Découvrir</h6>*/}
                      <h2>Stratégie</h2>
                      {/*<p><a href="#"><i className="ti-location-pin"></i> Ashburn, VA, United States</a></p>*/}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="text-left item bg-img" data-overlay-dark="3" data-background="./assets/images/gallery/ref_Transmission-Animation_.jpg">
            <div className="v-middle caption">
              <div className="container">
                <div className="row">
                  <div className="col-md-8">
                    <div className="o-hidden">
                      {/*<h6>Découvrir</h6>*/}
                      <h2>Transmission</h2>
                      {/*<p><a href="#"><i className="ti-location-pin"></i> Ashburn, VA, United States</a></p>*/}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="text-left item bg-img" data-overlay-dark="3" data-background="./assets/images/gallery/scarab.jpg">
            <div className="v-middle caption">
              <div className="container">
                <div className="row">
                  <div className="col-md-8">
                    <div className="o-hidden">
                      {/*<h6>Découvrir</h6>*/}
                      <h2>Etudes</h2>
                      {/*<p><a href="#"><i className="ti-location-pin"></i> Ashburn, VA, United States</a></p>*/}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="text-left item bg-img" data-overlay-dark="3" data-background="./assets/images/gallery/Transmission-Animation_3.jpg">
            <div className="v-middle caption">
              <div className="container">
                <div className="row">
                  <div className="col-md-8">
                    <div className="o-hidden">
                      {/*<h6>Découvrir</h6>*/}
                      <h2>Conférences</h2>
                      {/*<p><a href="#"><i className="ti-location-pin"></i> Ashburn, VA, United States</a></p>*/}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="text-left item bg-img" data-overlay-dark="3" data-background="./assets/images/gallery/vue-ensemble.PNG">
            <div className="v-middle caption">
              <div className="container">
                <div className="row">
                  <div className="col-md-8">
                    <div className="o-hidden">
                      {/*<h6>Découvrir</h6>*/}
                      <h2>Etude d'impact</h2>
                      {/*<p><a href="#"><i className="ti-location-pin"></i> Ashburn, VA, United States</a></p>*/}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="text-left item bg-img" data-overlay-dark="3" data-background="./assets/images/gallery/calculs.PNG">
            <div className="v-middle caption">
              <div className="container">
                <div className="row">
                  <div className="col-md-8">
                    <div className="o-hidden">
                      {/*<h6>Découvrir</h6>*/}
                      <h2>Echantillonnage</h2>
                      {/*<p><a href="#"><i className="ti-location-pin"></i> Ashburn, VA, United States</a></p>*/}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="text-left item bg-img" data-overlay-dark="3" data-background="./assets/images/gallery/equerre.jpeg">
            <div className="v-middle caption">
              <div className="container">
                <div className="row">
                  <div className="col-md-8">
                    <div className="o-hidden">
                      {/*<h6>Découvrir</h6>*/}
                      <h2>Quadrat</h2>
                      {/*<p><a href="#"><i className="ti-location-pin"></i> Ashburn, VA, United States</a></p>*/}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="text-left item bg-img" data-overlay-dark="3" data-background="./assets/images/gallery/trou.jpg">
            <div className="v-middle caption">
              <div className="container">
                <div className="row">
                  <div className="col-md-8">
                    <div className="o-hidden">
                      {/*<h6>Découvrir</h6>*/}
                      <h2>Pédologie</h2>
                      {/*<p><a href="#"><i className="ti-location-pin"></i> Ashburn, VA, United States</a></p>*/}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="text-left item bg-img" data-overlay-dark="3" data-background="./assets/images/gallery/tuyau.jpg">
            <div className="v-middle caption">
              <div className="container">
                <div className="row">
                  <div className="col-md-8">
                    <div className="o-hidden">
                      {/*<h6>Découvrir</h6>*/}
                      <h2>Zones humides</h2>
                      {/*<p><a href="#"><i className="ti-location-pin"></i> Ashburn, VA, United States</a></p>*/}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*<div className="text-left item bg-img" data-overlay-dark="3" data-background="./assets/images/gallery/fleurs2.jpg">*/}
          {/*    <div className="v-middle caption">*/}
          {/*        <div className="container">*/}
          {/*            <div className="row">*/}
          {/*                <div className="col-md-8">*/}
          {/*                    <div className="o-hidden">*/}
          {/*                        /!*<h6>Découvrir</h6>*!/*/}
          {/*                        <h2>Diversité</h2>*/}
          {/*                        /!*<p><a href="#"><i className="ti-location-pin"></i> Ashburn, VA, United States</a></p>*!/*/}
          {/*                    </div>*/}
          {/*                </div>*/}
          {/*            </div>*/}
          {/*        </div>*/}
          {/*    </div>*/}
          {/*</div>*/}
          {/*<div className="text-left item bg-img" data-overlay-dark="3" data-background="./assets/images/gallery/graines.jpg">*/}
          {/*    <div className="v-middle caption">*/}
          {/*        <div className="container">*/}
          {/*            <div className="row">*/}
          {/*                <div className="col-md-8">*/}
          {/*                    <div className="o-hidden">*/}
          {/*                        /!*<h6>Découvrir</h6>*!/*/}
          {/*                        <h2>Diversité</h2>*/}
          {/*                        /!*<p><a href="#"><i className="ti-location-pin"></i> Ashburn, VA, United States</a></p>*!/*/}
          {/*                    </div>*/}
          {/*                </div>*/}
          {/*            </div>*/}
          {/*        </div>*/}
          {/*    </div>*/}
          {/*</div>*/}
        </div>
      </div>

      {/*<GalleryComponent />*/}

      {/* <!-- hr --> */}
      <hr className="line-vr-section"/>
      {/* <!-- Top Footer Banner --> */}
      <div id="contact" className="topbanner-footer" data-scroll-index="9">
        <div className=" banner-img valign bg-img bg-fixed" data-overlay-light="4" data-background="./savoye/img/slider/1.jpg">
          <div className="container">
            <div className="row">
              <div className="col-md-12 mb-30 text-left caption">
                <div className="section-title mt-4">Contactez-nous</div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <h6>Téléphone</h6>
                <a href="tel:+330602164048"> <h5 className="mb-30">(+33) 06.02.16.40.48</h5></a>
              </div>
              <div className="col-md-8">
                <h6>Email</h6>
                <a href="mailto:kelly?thomas.naturae@gmail.com"> <h5 className="mb-30">kelly.thomas.naturae@gmail.com</h5></a>
              </div>

            </div>
          </div>
        </div>
      </div>
      {/* <!-- Footer --> */}
      <footer id="footer" className="main-footer dark">

        <div className="sub-footer">
          <div className="container">
            <div className="row">
              <div className="col-md-8">
                <div className="text-left">
                  <p>© 2025, NATURAE Biodiversité. Tous droits réservés.</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="text-right-left">
                  <p><a href="#">Mentions légales</a> {/*<span>|</span> <a href="#"> Conditions générales de vente</a>*/}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>


  );
}
